export default "__VITE_ASSET__866f9540__"